import {
  LOCATION_CAPACITY_MODIFIER,
  LOCATION_COST_MODIFIER,
  LOCATION_TIME_MODIFIER,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

const getLocationDefaults = () => ({
  [LOCATION_CAPACITY_MODIFIER]: '1',
  [LOCATION_COST_MODIFIER]: '1',
  [LOCATION_TIME_MODIFIER]: '1',
});

export default getLocationDefaults;
